import type { ReactNode } from "react";
import "./ScheduleAlertsList.scss";
import type { ScheduleAlert } from "@/pages/human-resources/time-management/business/schedule/ScheduleAlert.ts";
import { useTranslation } from "react-i18next";
import ScheduleAlertsGroup from "@/pages/human-resources/time-management/components/schedule-alerts/alerts-list/ScheduleAlertsGroup.tsx";
import useRevealEmployeeById from "@/pages/human-resources/time-management/schedules/site-schedule/grouped-rows/useRevealEmployee.ts";

interface Properties {
  blockingAlerts: ScheduleAlert[];
  warningAlerts: ScheduleAlert[];
}

export default function ScheduleAlertsList(props: Properties): ReactNode {
  const { t } = useTranslation(["common", "humanResources"]);
  const revealEmployeeId = useRevealEmployeeById();
  const nbAlerts = props.blockingAlerts.length + props.warningAlerts.length;
  return (
    <div className="schedule-alerts">
      {nbAlerts === 0 ?
        <div className="all-right">
          {t("humanResources:timeManagement.scheduleAlerts.success")}
        </div>
      : <>
          <ScheduleAlertsGroup
            level="BLOCKING"
            alerts={props.blockingAlerts}
            revealEmployeeId={revealEmployeeId}
          />
          <ScheduleAlertsGroup
            level="WARNING"
            alerts={props.warningAlerts}
            revealEmployeeId={revealEmployeeId}
          />
        </>
      }
    </div>
  );
}
